import React, { lazy,Component } from 'react';
import {withRouter} from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import intl from 'react-intl-universal';
import { Spin, Modal, Progress } from "antd";
import PageLayout from "./PageLayout";
import {LoadingPage} from '../pages/index';
import {store} from '../store/index'
import { appStoreCloudApis, baseUrlApis, isMobile } from 'Api/index';
import {
    isPdfOnlineDomain,
    /*isCommonFeatureDomain,*/
    updateProp,
    // isCanvas, 
    isCNDomain, isJPDomain, getQueryVariable, /*getEnterpriseIdFromStorage*/
} from 'Utils/utils';
import { SignInNoticeDialog, MessageDialog , SubscribeDialog} from "Components/dialogs/index";
import wrapDialog from './wrapperDialog';
import { GOT_USER_SUBSCRIPTION } from 'Store/constants';
import {
    NEED_NAV_AFTER_PAY
} from 'Components/viewer/ui/constants/event.constants.share';
import {
    /*TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_SIGNIN_BUTTON,*/
    TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_CANCEL_BUTTON,
    TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_LABEL
} from 'Components/viewer/ui/constants/user.more.constants';
// import { isDTRuntime } from '@/modules/3rd-party-integration/utils/env';
// import { DingtalkModule } from '@/modules/dingtalk/lazy-load';
// import LittleHelper from 'components/LittleHelper/index';
import { thirdPartyService } from '@/store/services';

const Redeem = lazy(()=>import('components/dialogs/RedeemDlg/Redeem.page'))

@inject("appStore", "userStore", "loginNewStore", 'userNewStore', "teamsAppStore","accountStore")
@observer
class PageLayoutWrapper extends Component {
    constructor(props) {
        super(props);
        this.state  = {
        }
        //store.appStore.setAppTitle();
        this.onOkFromSignIn = this.onOkFromSignIn.bind(this);
        this.onCancelFromSignIn = this.onCancelFromSignIn.bind(this);
        this.onCloseWindow = this.onCloseWindow.bind(this);
    }
    onCloseWindow(){
        window.opener = null;
        updateProp(location, 'href', "about:blank")
        window.close();
    }
    componentDidMount(){
        // let pathname = prop(location, 'pathname');
        let isDebug = baseUrlApis.getQueryVariable('debug');
        if(isDebug === 'debugger'){
            alert('routes debugger')
            debugger;
        }
        if(isMobile()){
            // fo__ui-mobile fv__ui-mobile
            document.documentElement.classList.add("fo__ui-mobile")
        }

        if(this.props.location && this.props.location.pathname === '/logout/success'){
            this.onCloseWindow();
            return
        }

        store.appStore.addAppEventListener(GOT_USER_SUBSCRIPTION,()=>{
            this.checkForFirstLoginPayment();
        });

        store.appStore.addAppEventListener('need-pay-event',(fromFun)=>{
            if(fromFun && store.teamsAppStore.inTeamsApp){
                this.checkForFirstLoginPayment();
            }
        });
        // load global config => init
        // TODO FOXIT 这里获取了全局的api地址信息，云编辑去除该逻辑
        store.appStore.initGlobalConfig({});
        store.appStore.updateLoading(false);
        window.onlineGlobals = {
            showAllTooltip:true
        }
        window.goToOnlineFromTeam = this.goToOnlineFromTeam;
        // baseUrlApis.loadUrlConfig().then((cfg)=>{
        //     store.appStore.initGlobalConfig(cfg);
        //     // TODO FOXIT 去除原有登录信息获取
        //     // store.userStore.initializeOnFirst(()=>{
        //     //     store.appStore.updateLoading(false);
        //     //     window.onlineGlobals = {
        //     //         showAllTooltip:true
        //     //     }
        //     // }, pathname);
        //     store.appStore.updateLoading(false);
        //     window.onlineGlobals = {
        //         showAllTooltip:true
        //     }
        // }).catch((/* err */)=>{
        //     store.appStore.updateLoading(false);
        //     store.appStore.showMessageDlg({ msg:{id:"Error:404"} })
        // });

    }
    componentWillUnmount(){
    }

    goToOnlineFromTeam = ()=>{
        store.userStore.doGoToOnlineFromTeam();
    }

    checkForFirstLoginPayment = async ()=>{
        if(!isCNDomain()&&!isJPDomain()){
            const showDia = async ()=>{
                const { isEnterpriseUser } = store.userStore;
                const isEdu = await appStoreCloudApis.doCheckEdu(null);
                if(!isEnterpriseUser && !isEdu){
                    window.pdfui.eventEmitter.emit('need-pay-event');
                }
            }
            const userEmail = store.userStore.userInfo.userEmail;
            const userFirstInMap = JSON.parse(window.localStorage.getItem('is_f_in')||'{}');
            const notFirstLogin = userFirstInMap[userEmail];
            const {isNoFirstTrail} =store.accountStore;
            let navAfterPayDlg = false;
            if(!notFirstLogin && isNoFirstTrail){
                if (!thirdPartyService.isFromThirdParty()) {
                    await showDia();
                }
                navAfterPayDlg = true;
                userFirstInMap[userEmail] = true;
                window.localStorage.setItem('is_f_in',JSON.stringify(userFirstInMap));
            }
            window.localStorage.setItem('navAfterPayDlg',navAfterPayDlg);

            store.appStore.emitEvent(NEED_NAV_AFTER_PAY,navAfterPayDlg);

            // open from teams
            const isFromTeams = getQueryVariable('from')==='teamsub';
            if(isFromTeams){
                const timer = setInterval(()=>{
                    if(store.userStore.token){
                        clearInterval(timer);
                        showDia();
                    }
                },1000);
            }
        }else{
            store.appStore.emitEvent(NEED_NAV_AFTER_PAY,false)
        }
    }
   
    // TODO FOXIT 提示用户token失效，重新获取token 需要登录，修改为userNewStore、loginNewStore判断
    onOkFromSignIn(){
        if(store.loginNewStore.isLogin) {
            store.userNewStore.getToken()
            store.appStore.doUpdateSignInNotice(null)
        } else {
            store.loginNewStore.login()
        }
        // let reLogin = false;
        // msg && msg.reLogin && (reLogin = true)
        // store.appStore.doUpdateSignInNotice(null);
        // if(!reLogin){
        //     store.userStore.loginIn();
        //     return;
        // }
        // if (store.teamsAppStore.inTeamsApp) {
        //     store.userStore.reLogin(false);
        // } else {
        //     store.userStore.reLogin(true);
        // }
    }
    onCancelFromSignIn(){
        let { noticeDialog } = store.appStore;
        if (noticeDialog) {
            if (noticeDialog.isFromTokenExpired) {
                store.userStore.doSendGAEventByUser({eventKey: TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_CANCEL_BUTTON, label: TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_LABEL})
            }
            store.appStore.doUpdateSignInNotice(null);
        }
    }

    onCloseSubscribeDialog =()=>{
        let { noticeDialog } = store.appStore;
        if (noticeDialog) {
            if (noticeDialog.isFromTokenExpired) {
                store.userStore.doSendGAEventByUser({eventKey: TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_CANCEL_BUTTON, label: TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_LABEL})
            }
            store.appStore.doUpdateSignInNotice(null);
        }
    }
    render() {
        const {loading, noticeDialog, loadingMessage, progressingInfo: { show: showProgressing, percent }, globalModalConfig, isShowMessageDlg, messageDlgCfg, lng } = store.appStore;
        const { isEdu, isShowSubscribe, isShowRedeemDlg} = store.userStore;
        // const { isLogin } = store.loginNewStore

        let config = {
            // spinning:loadingMessage.show,
            spinning:false,
            tip: loadingMessage.msg ?intl.get(loadingMessage.msg): undefined,
            size: "large"
        }
        let showRedeemDlg = isShowRedeemDlg && (!((isPdfOnlineDomain() || isCommonFeatureDomain()) && !isEdu)) && hasSignIn;

        // let _isShowLittleHelper = isShowLittleHelper && !isCanvas() && aiUIFlag === 3 && isAISupported();
        
        return (
            <React.Fragment>
                <Modal {...globalModalConfig}/>
                {loading && <LoadingPage/> }
                { showProgressing && <div className='loading-file-progress'>
                    <div className='progress-wrapper'>
                        <Progress percent={percent} size="small" showInfo={false} strokeColor="#B52FB8" trailColor="#B7B7B7"/>
                        <span>{intl.get('Loading.file')}</span>
                    </div>
                </div> }
                <Spin className={'page-loading'} {...config} wrapperClassName='in-center'>
                    {!loading && <PageLayout location={this.props.location} lng={lng}/> }
                </Spin>
                {!!noticeDialog && wrapDialog(<SignInNoticeDialog msg={noticeDialog} visible={!!noticeDialog} onOk={this.onOkFromSignIn} onClose={this.onCancelFromSignIn}/>)}
                {!!isShowMessageDlg && <MessageDialog {...messageDlgCfg} visible={!!isShowMessageDlg} />}
                {!!isShowSubscribe && hasSignIn && wrapDialog(<SubscribeDialog visible={!!isShowSubscribe} onClose={this.onCloseSubscribeDialog}/>) }
                {/* {_isShowLittleHelper && <LittleHelper></LittleHelper>} */}
                {!!showRedeemDlg && wrapDialog(<Redeem></Redeem>)}
                {/* {isDTRuntime && <DingtalkModule.DingtalkInitialize />} */}
            </React.Fragment>
        )
    }
}


// DefaultRoutes
//const Routes = DefaultRoutes;
// export default Routes
export default withRouter(PageLayoutWrapper)
